
import React, { useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import styled from "styled-components";
import { AppContext } from "../../../contexts/AppContext";


const EditDataSetSidebarWrapper = styled.div`
  width: 250px;
  background-color: var(--sidebar-bg);
  border: 1px solid var(--sidebar-border-color);
  box-sizing: content-box;
  margin-left: -20px;
  margin-top: -40px;
  z-index: 1;

  height: auto;
  position:sticky;
`;

const EditDataSetSidebarInnerWrapper = styled.div`
  width: 250px;
  overflow: hidden auto;
  height: 100vh;
  padding: 20px 16px 8px 16px;
  display: flex;
  flex-direction: column;
  position: fixed;
`;

const EditDataSetSidebarItems = styled.div`
  margin-top: 20px;
`;

const EditDataSetSidebarItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  padding: 13px 5px 13px 10px;
  border-radius: 8px;
  cursor: pointer;

  &.active {
    background-color: var(--sidebar-active-item-bg);
  }

  &.active  * {
    color: var(--sidebar-active-item-color) !important;
  }

  &:hover:not(.active) {
    background-color: var(--sidebar-active-item-bg);
  }
`;

const EditDataSetSidebarItemText = styled.span`
  font-size: 16px;
  font-weight: 300;
  color: var(--sidebar-item-color);
  padding-left: 10px;
`;

const EditDataSetSidebarItemIcon = styled(Icon)`
  font-size: 18px;
  color: var(--sidebar-item-color);
`;

export const EditDataSetSidebar = ({
  defaultSelectedTab = window.location.hash ? window.location.hash.substr(1) : "details",
  onNavItemClicked = () => { },
}) => {
  console.log("!!! DEFAULT SELECTED TAB: ", defaultSelectedTab)
  const [selectedTab, setSelectedTab] = useState(defaultSelectedTab);

  const { selectedClient } = useContext(
    AppContext
  );
  console.log("!!! SIDEBAR SELECTED CLIENT: ", selectedClient)

  useEffect(() => {
    setSelectedTab(defaultSelectedTab);
  }, [defaultSelectedTab]);

  useEffect(() => {
    window.history.pushState(null, null, `#${selectedTab}`);
    onNavItemClicked(selectedTab);

    // eslint-disable-next-line
  }, [selectedTab]);

  const selectTab = (tab) => {
    setSelectedTab(tab);
    // Update to use the has of the tab
  };

  const isSelected = (tab) => {
    console.log("!!! CHECKING IF SELECTED: ", tab, selectedTab, selectedTab === tab);
    return selectedTab === tab ? "active" : "";
  }


  return (
    <EditDataSetSidebarWrapper
      className={
        "block top-0 bottom-0 w-64 bg-white left-0 absolute flex-row flex-nowrap md:z-10 z-9999 transition-all duration-300 ease-in-out transform "
      }
      style={{}}
    >
      <EditDataSetSidebarInnerWrapper>
        <EditDataSetSidebarItems style={{ flexGrow: 0 }}>
          <EditDataSetSidebarItem className={isSelected("details")} onClick={() => selectTab("details")}>
            <span>
              <EditDataSetSidebarItemIcon icon="lucide:info" />
            </span>
            <EditDataSetSidebarItemText>Details</EditDataSetSidebarItemText>
          </EditDataSetSidebarItem>
          <EditDataSetSidebarItem className={isSelected("metadata")} onClick={() => selectTab("metadata")}>
            <span>
              <EditDataSetSidebarItemIcon icon="lucide:braces" />
            </span>
            <EditDataSetSidebarItemText>Metadata</EditDataSetSidebarItemText>
          </EditDataSetSidebarItem>
          <EditDataSetSidebarItem className={isSelected("ingest-workflow")} onClick={() => selectTab("ingest-workflow")}>
            <span>
              <EditDataSetSidebarItemIcon icon="lucide:bot" />
            </span>
            <EditDataSetSidebarItemText>Ingest Workflow</EditDataSetSidebarItemText>
          </EditDataSetSidebarItem>
          <EditDataSetSidebarItem
            className={isSelected("dynamic-workflow")}
            onClick={() => selectTab("dynamic-workflow")}
            title="Edit the ingestion graph with the new dynamic nodes"
          >
            <span>
              <EditDataSetSidebarItemIcon icon="lucide:square-arrow-out-up-right" />
            </span>
            <EditDataSetSidebarItemText>Dynamic Graph</EditDataSetSidebarItemText>
          </EditDataSetSidebarItem>
          <EditDataSetSidebarItem className={isSelected("data-items")} onClick={() => selectTab("data-items")}>
            <span>
              <EditDataSetSidebarItemIcon icon="lucide:files" />
            </span>
            <EditDataSetSidebarItemText>Data Items</EditDataSetSidebarItemText>
          </EditDataSetSidebarItem>
        </EditDataSetSidebarItems>
      </EditDataSetSidebarInnerWrapper>
    </EditDataSetSidebarWrapper>
  );
};

export default EditDataSetSidebar;
